'use client'
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../constants/values.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';

// use this in conjuction with dynamic_enableTroubleshootMode to see
// more verbose logging to help troubleshoot issues
// i.e: window.dynamic_enableTroubleshootMode = true
const logVerboseTroubleshootingMessage = (message, ...args) => {
    logger.log(-1, message, ...args);
};

export { logVerboseTroubleshootingMessage };
